var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlackLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7992 0C7.47252 0.000978593 6.39881 1.07547 6.39979 2.39951C6.39881 3.72355 7.4735 4.79804 8.80018 4.79902H11.2006V2.40049C11.2016 1.07645 10.1269 0.00195719 8.7992 0C8.80019 0 8.80019 0 8.7992 0V0ZM8.7992 6.4H2.40012C1.07343 6.40098 -0.00125253 7.47547 -0.000271978 8.79951C-0.00223308 10.1235 1.07245 11.198 2.39914 11.2H8.7992C10.1259 11.199 11.2006 10.1245 11.1996 8.80049C11.2006 7.47547 10.1259 6.40098 8.7992 6.4Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9999 8.79951C24.0009 7.47547 22.9262 6.40098 21.5996 6.4C20.2729 6.40098 19.1982 7.47547 19.1992 8.79951V11.2H21.5996C22.9262 11.199 24.0009 10.1245 23.9999 8.79951ZM17.5999 8.79951V2.39951C17.6009 1.07645 16.5272 0.00195719 15.2005 0C13.8738 0.000978593 12.7991 1.07547 12.8001 2.39951V8.79951C12.7981 10.1235 13.8728 11.198 15.1995 11.2C16.5262 11.199 17.6009 10.1245 17.5999 8.79951Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1995 24C16.5262 23.999 17.6009 22.9245 17.5999 21.6005C17.6009 20.2765 16.5262 19.202 15.1995 19.201H12.7991V21.6005C12.7981 22.9236 13.8728 23.998 15.1995 24ZM15.1995 17.599H21.5996C22.9262 17.598 24.0009 16.5236 24 15.1995C24.0019 13.8755 22.9272 12.801 21.6005 12.799H15.2005C13.8738 12.8 12.7991 13.8745 12.8001 15.1985C12.7991 16.5236 13.8728 17.598 15.1995 17.599Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.03647e-05 15.1995C-0.00104092 16.5235 1.07364 17.598 2.40033 17.599C3.72702 17.598 4.8017 16.5235 4.80072 15.1995V12.8H2.40033C1.07364 12.801 -0.00104092 13.8754 -6.03647e-05 15.1995ZM6.4 15.1995V21.5995C6.39804 22.9235 7.47273 23.998 8.79942 24C10.1261 23.999 11.2008 22.9245 11.1998 21.6005V15.2014C11.2018 13.8774 10.1271 12.8029 8.8004 12.801C7.47273 12.801 6.39902 13.8754 6.4 15.1995C6.4 15.1995 6.4 15.2005 6.4 15.1995Z",
    fill: "#E01E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLogo);
export default __webpack_public_path__ + "static/media/SlackLogo.3b75d19f3e7b2f689499fa1e5f441bde.svg";
export { ForwardRef as ReactComponent };